import React, { Component } from "react";
import { Grid, Row, Col, Image, Button } from "react-bootstrap";
import Header from "./Header.jsx";
import Banner from "./Banner.jsx";
import BackButton from "./BackButton.jsx";
import hyperlinks from "../../../src/util/hyperlinks";



export default class Membership extends Component {
    render() {
        return (
            <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
                <Grid className="with-background">
                    <Banner heading="Membership" />
                    <BackButton href={hyperlinks["home"]} text="❮ Home" />
                    <Image src="/assets/LUOW Group Photo 2023-5fef340aaedad45008c6c538f52c7e142922ae12dfb14b980af03d5830c9e983.jpg" />
                    <Button className="current-members" href={hyperlinks["currentMembers"]}>{"Current members ❯"}</Button>
                    <Row>
                        <Col md={4}>
                            <div className="becoming-a-member">
                                <h2>Becoming A Member</h2>
                                <p>Membership of the Leading Utilities of the World is the gold standard for utility performance and innovation.</p>
                                <Button href={hyperlinks["newMember"]}>Learn More</Button>
                            </div>
                        </Col>
                        <Col md={8}>
                            <div className="membership-content">
                                <h2>What it means to be a member</h2>
                                <p>
                                    Members of the Leading Utilities of the World (LUOW) network are among the best water utilities in the world. Being a member is the gold standard for current and future performance and innovation.
                                </p>

                                <p>
                                    Current utility members of LUOW have access to a number of benefits:
                                </p>

                                <ul>
                                    <li>
                                        <span className="blue-text"><strong>Reputation:</strong></span> Once a utility has been approved for LUOW membership, its leadership and staff can feel proud of their achievement of becoming one of the best water utilities in the world.
                                    </li>

                                    <li>
                                        <span className="blue-text"><strong>Trophy:</strong></span> Utility members receive the iconic 'Golden Tap' trophy and framed certificate to commemorate their membership during the event at which they are inaugurated.
                                    </li>

                                    <li>
                                        <span className="blue-text"><strong>Face-To-Face Meetings:</strong></span> The leaders of the member utilities are encouraged to take part in future face-to-face LUOW events, by way of invitations from the LUOW Secretariat. The face-to-face meetings are a vital part of the continuing collaboration, networking, and experience-sharing between utilities.
                                    </li>

                                    <li>
                                        <span className="blue-text"><strong>Online Promotion:</strong></span> Firstly, members can publicise their involvement in the LUOW network, both on their own website by way of a bespoke LUOW logo, as well as on the LUOW website. On the main LUOW website, each utility is sub-divided into specific innovation areas which demonstrate the aspirational nature of their operations. Inclusion in the LUOW network, and therefore on the website, is demonstrative of the approval given by the LUOW Advisory Board which is made up of other water utilities with unimpeachable records of performance.
                                    </li>

                                    <li>
                                        <span className="blue-text"><strong>Online Networking:</strong></span> Members can access the members-only area of the LUOW website and communicate with thought leaders around the world online.
                                    </li>
                                </ul>

                                <p>
                                    Being a member of LUOW both promotes your utility's existing outstanding innovations and will help you find solutions to your challenges via utility-to-utility collaboration and knowledge-sharing.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </Header>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/Membership.jsx.erb